import React from 'react';
import { Gift, Sparkles } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const bonos = [{
  num: 1,
  title: 'Rutina Exprés de 15 Minutos en Casa',
  value: '$12.000',
  desc: 'Para los días sin entrenamiento. Activación, movilidad, reflejos y técnica en cualquier lugar sin equipamiento.'
}, {
  num: 2,
  title: '30 Drills de Armado Listos para Usar',
  value: '$10.000',
  desc: 'Biblioteca completa organizada por nivel con diagramas de cancha y tarjetas listas para imprimir.'
}, {
  num: 3,
  title: 'Guía de Distribución Táctica',
  value: '$9.000',
  desc: 'Árboles de decisión, diagramas tácticos y guía de referencia rápida para estudiar antes de cada partido.'
}, {
  num: 4,
  title: 'Plan de Calentamiento Específico para Partidos',
  value: '$10.000',
  desc: 'Rutina completa de entrada en calor con activación técnica, movilidad articular y preparación mental.'
}, {
  num: 5,
  title: 'Test de Autoevaluación del Armador',
  value: '$9.000',
  desc: 'Medí tu nivel real en los 5 pilares con gráfico radar de perfil y plan de acción según tus resultados.'
}, {
  num: 6,
  title: 'Mini Guía Mental: Cómo Tomar Decisiones Bajo Presión',
  value: '$8.000',
  desc: 'El sistema de reseteo de 3 segundos, rutina de visualización pre partido y 6 técnicas de concentración élite.'
}];
export const BonosSection = () => {
  return <section className="py-12 md:py-24 bg-navy-950 border-t border-navy-800 relative overflow-hidden" data-id="element-15">
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-gold-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-16" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-17">
        <FadeIn className="text-center mb-8 md:mb-16" data-id="element-18">
          <div className="inline-flex items-center gap-2 mb-3 px-4 py-1 rounded-full bg-gold-500/10 border border-gold-500/40" data-id="element-19">
            <Gift className="w-4 h-4 text-gold-500" data-id="element-20" />
            <span className="text-xs uppercase tracking-widest text-gold-500 font-bold" data-id="element-21">
              Regalos Exclusivos
            </span>
          </div>
          <h2 className="text-4xl md:text-7xl font-bebas text-white mb-3 md:mb-4" data-id="element-22">
            Más los 6 Bonos <span className="text-gold-500" data-id="element-23">Estratégicos</span>
          </h2>
          <p className="text-base md:text-xl text-gray-300 font-medium uppercase tracking-widest" data-id="element-24">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 mb-8 md:mb-16" data-id="element-25">
          {bonos.map((bono, i) => <FadeIn key={i} delay={i * 0.08} className="relative bg-gradient-to-br from-navy-900 to-navy-950 border border-gold-500/30 rounded-xl p-4 md:p-6 group hover:border-gold-500/70 hover:shadow-[0_0_30px_rgba(212,175,55,0.2)] transition-all duration-500 overflow-hidden" data-id="element-26">
              {/* Ribbon */}
              <div className="absolute -top-1 -right-1 bg-gold-500 text-navy-950 text-[10px] md:text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider shadow-lg" data-id="element-27">
                GRATIS
              </div>

              {/* Number badge */}
              <div className="flex items-center gap-3 mb-3 md:mb-4" data-id="element-28">
                <div className="relative" data-id="element-29">
                  <div className="text-3xl md:text-4xl" data-id="element-30">🎁</div>
                </div>
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-navy-800 border border-gold-500/40 text-gold-500 font-bebas text-lg" data-id="element-31">
                  {bono.num}
                </div>
              </div>

              <h3 className="text-base md:text-xl font-bold text-white mb-2 leading-tight" data-id="element-32">
                {bono.title}
              </h3>
              <div className="flex items-center gap-2 mb-2 md:mb-4 text-xs md:text-sm font-bold" data-id="element-33">
                <span className="text-gray-500 line-through" data-id="element-34">
                  Valor: {bono.value}
                </span>
                <span className="text-gold-500 flex items-center gap-1" data-id="element-35">
                  <Sparkles className="w-3 h-3" data-id="element-36" /> Incluido
                </span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-37">
                {bono.desc}
              </p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.2} className="text-center" data-id="element-38">
          <div className="inline-block relative" data-id="element-39">
            <div className="absolute inset-0 bg-gold-500/30 blur-2xl rounded-xl" data-id="element-40" />
            <div className="relative inline-block bg-gradient-to-r from-gold-600 via-gold-400 to-gold-600 text-navy-950 font-bebas text-xl md:text-4xl px-5 md:px-8 py-3 md:py-4 rounded-xl shadow-[0_0_40px_rgba(212,175,55,0.5)] border border-gold-300" data-id="element-41">
              Valor total:{' '}
              <span className="line-through opacity-60" data-id="element-42">$58.000</span> → 🎁
              GRATIS
            </div>
          </div>
          <p className="text-gray-400 mt-4 text-sm md:text-base" data-id="element-43">
            Incluidos siempre en ambas opciones
          </p>
        </FadeIn>
      </div>
    </section>;
};